import { useUser } from '~/@biz_account/useUser/useUser'
import type { ProjectsItem } from '../../_project_types/project.types'
import { isProjectBlurred } from '../project-blurred-content/isProjectBlurred'
import { ProjectPreviewImageAndPopup } from './ProjectPreviewImageAndPopup'

type Props = {
  project: ProjectsItem
}

function ProjectPreviewImageAndPopupCell({ project }: Props) {
  const { user } = useUser()
  const isBlurred = isProjectBlurred(project.blurTags, user?.meta?.tags)

  return (
    <ProjectPreviewImageAndPopup withPopup={!isBlurred} project={project} />
  )
}

export { ProjectPreviewImageAndPopupCell }
